import { $, $$, throttledInterval, clearThrottled } from './utils.js';
import { T, lang } from './i18n.js';
import { typeText, fireFireworks, addSparkles, startExhaust, stopExhaust } from './effects.js';
import { _beanHideForOverlay, _beanShowAfterOverlay, setOpenMakeoverOverlay } from './bean.js';

/* ─── Makeover overlay ────────────────── */
const mkOverlay = $('#makeover-overlay');
const mkForm = $('#makeover-form');
const mkFormWrap = $('#makeover-form-wrap');
const mkSuccess = $('#makeover-success');

const beanBusinessTexts = {
	en: 'Oh, you are wise. Yes, let\u2019s get to business.',
	nl: 'Oh, u bent wijs. Ja, laten we aan de slag gaan.',
};
// Enquiries are emailed to the owner; there is no build token/status any more.
// A simple flag remembers that this visitor already sent one (returning
// visitors see the thank-you view). The old preview token key is cleaned up.
const ENQUIRED_KEY = 'sm_makeover_enquired';
try { localStorage.removeItem('sm_makeover_token'); } catch {}
let hasSubmitted = (() => { try { return !!localStorage.getItem(ENQUIRED_KEY); } catch { return false; } })();

function thanksText() {
	return T[lang]?.referralNote || T.en.referralNote;
}
let fireworksInterval = null;

export function openMakeoverOverlay() {
	if (_beanHideForOverlay) _beanHideForOverlay();
	document.documentElement.classList.add('overlay-open');
	mkOverlay.classList.add('active');
	_openMakeoverOverlayInner();
}

// Register with bean.js so Bean click can open overlay
setOpenMakeoverOverlay(openMakeoverOverlay);

function _openMakeoverOverlayInner() {
	if (hasSubmitted) {
		// Show referral view (returning visitor)
		const leftHalf = mkOverlay.querySelector('.makeover-left');
		const rightHalf = mkOverlay.querySelector('.makeover-right');
		if (leftHalf) leftHalf.style.display = 'none';
		if (rightHalf) rightHalf.style.display = 'none';
		const refWrap = $('#referral-wrap');
		const refCard = $('#referral-card');
		const codeWrap = $('#referral-code-wrap');
		refWrap.classList.add('active');
		refCard.classList.add('active');
		codeWrap.classList.add('visible');
		// Bean already gone — show panel centered with submit-another visible
		const refInner = refWrap.querySelector('.makeover-inner');
		if (refInner) refInner.classList.add('bean-gone');
		const sa = refWrap.querySelector('.submit-another');
		if (sa) sa.classList.add('visible');
		const behind = $('#fw-behind');
		startContinuousFireworks(behind);
		typeText($('#referral-typewriter'), thanksText(), { startDelay: 400 });
	} else {
		mkFormWrap.style.display = '';
		mkSuccess.classList.remove('active');
		// Reset any lingering Bean animations before opening
		const overlayBean = mkOverlay.querySelector('.overlay-bean');
		if (overlayBean) {
			overlayBean.style.transition = 'none';
			overlayBean.style.animation = '';
			overlayBean.style.transform = '';
			overlayBean.offsetHeight; // force reflow
			overlayBean.style.transition = '';
		}
		const el = $('#bean-overlay-typewriter');
		if (el) typeText(el, beanBusinessTexts[lang] || beanBusinessTexts.en, { startDelay: 400 });
	}
}

function startContinuousFireworks(container) {
	if (fireworksInterval) clearThrottled(fireworksInterval);
	const startTime = performance.now();
	// Ramp down from 800ms interval / 3 bursts to ~12s interval / 1 burst over 60s
	let nextFire = performance.now();
	fireworksInterval = throttledInterval(() => {
		if (!mkOverlay.classList.contains('active')) { clearThrottled(fireworksInterval); return; }
		const now = performance.now();
		const elapsed = now - startTime;
		// Ease from 800ms to 12000ms over 60s
		const t = Math.min(elapsed / 60000, 1);
		const interval = 800 + t * t * 11200;
		if (now < nextFire) return;
		nextFire = now + interval;
		// Ease burst count from 3 to 1 and particles from 8 to 4
		const bursts = Math.max(1, Math.round(3 - t * 2));
		const particles = Math.max(4, Math.round(8 - t * 4));
		fireFireworks(container, bursts, particles, 0);
	}, 200);
}

$('#open-makeover')?.addEventListener('click', openMakeoverOverlay);
$$('.open-makeover-btn').forEach(b => b.addEventListener('click', openMakeoverOverlay));
$$('.step-card').forEach(c => c.addEventListener('click', openMakeoverOverlay));

export function closeOverlay() {
	document.documentElement.classList.remove('overlay-open');
	mkOverlay.classList.remove('active');
	if (fireworksInterval) clearThrottled(fireworksInterval);
	// Restore floating Bean
	if (_beanShowAfterOverlay) _beanShowAfterOverlay();
	if (!hasSubmitted) {
		// Only reset form state if not submitted
		const leftHalf = mkOverlay.querySelector('.makeover-left');
		const rightHalf = mkOverlay.querySelector('.makeover-right');
		if (leftHalf) { leftHalf.classList.remove('exit'); leftHalf.style.display = ''; }
		if (rightHalf) { rightHalf.classList.remove('exit'); rightHalf.style.display = ''; }
		const refWrap = $('#referral-wrap');
		const refCard = $('#referral-card');
		const codeWrap = $('#referral-code-wrap');
		if (refWrap) refWrap.classList.remove('active');
		if (refCard) refCard.classList.remove('active');
		if (codeWrap) codeWrap.classList.remove('visible');
		const behind = $('#fw-behind');
		if (behind) behind.innerHTML = '';
	}
}

$('#makeover-close')?.addEventListener('click', closeOverlay);
document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && mkOverlay.classList.contains('active')) closeOverlay();
});

// Submit another site
$('#submit-another')?.addEventListener('click', (e) => {
	e.preventDefault();
	hasSubmitted = false;
	mkSubmitting = false;
	if (fireworksInterval) clearThrottled(fireworksInterval);
	// Animate panel back to make room for Bean
	mkOverlay.querySelectorAll('.makeover-inner').forEach(el => el.classList.remove('bean-gone'));
	mkOverlay.querySelectorAll('.submit-another').forEach(el => el.classList.remove('visible'));
	const leftHalf = mkOverlay.querySelector('.makeover-left');
	const rightHalf = mkOverlay.querySelector('.makeover-right');
	if (leftHalf) { leftHalf.classList.remove('exit'); leftHalf.style.display = ''; }
	if (rightHalf) { rightHalf.classList.remove('exit'); rightHalf.style.display = ''; }
	const refWrap = $('#referral-wrap');
	const refCard = $('#referral-card');
	const codeWrap = $('#referral-code-wrap');
	if (refWrap) refWrap.classList.remove('active');
	if (refCard) refCard.classList.remove('active');
	if (codeWrap) codeWrap.classList.remove('visible');
	const behind = $('#fw-behind');
	if (behind) behind.innerHTML = '';
	mkForm.reset();
	mkSubmit.disabled = false;
	mkSubmit.textContent = T[lang]?.overlaySubmit || 'Send enquiry';
	mkFormWrap.style.display = '';
	setMkStatus('');

	// Reset overlay Bean animations
	const refRight2 = refWrap?.querySelector('.makeover-right');
	if (refRight2) {
		refRight2.classList.remove('bean-hidden', 'bean-can-talk');
		refRight2.style.opacity = '';
		const beanEl2 = refRight2.querySelector('.overlay-bean');
		if (beanEl2) { beanEl2.style.animation = ''; beanEl2.style.transform = ''; }
		const mascotCircle2 = refRight2.querySelector('.mascot-small');
		if (mascotCircle2) mascotCircle2.style.animation = '';
	}

	// Bring back floating Bean
	const floater = $('#bean-float');
	if (floater) { floater.style.display = ''; }

	// Hide and clear ALL speech bubbles during landing
	const refRight3 = mkOverlay.querySelector('.referral-wrap .makeover-right');
	if (refRight3) refRight3.classList.remove('bean-can-talk');
	const rtEl = $('#referral-typewriter');
	if (rtEl) rtEl.textContent = '';
	const botEl = $('#bean-overlay-typewriter');
	if (botEl) botEl.textContent = '';
	// Also hide the form-side bean speech
	const formRight = mkOverlay.querySelector('.makeover-inner:first-child .makeover-right');
	if (formRight) formRight.classList.remove('bean-can-talk');

	// Bean lands from the sky in the overlay
	const overlayBeanEl = mkOverlay.querySelector('.makeover-inner .overlay-bean');
	if (overlayBeanEl) {
		// Show speech bubble for descent text
		overlayBeanEl.querySelectorAll('.bean-overlay-speech').forEach(b => b.style.display = '');
		if (formRight) formRight.classList.add('bean-can-talk');
		// Type "eyyyyyy..." during descent
		const descentEl = $('#bean-overlay-typewriter');
		if (descentEl) typeText(descentEl, 'eyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy', { delay: 250, jitter: 80, startDelay: 800 });
		// Rumble during descent
		const landingMascot = overlayBeanEl.querySelector('.mascot-small');
		if (landingMascot) landingMascot.style.animation = 'beanVibrate 0.3s linear infinite';
		overlayBeanEl.style.animation = 'beanLanding 9s cubic-bezier(0.2, 0, 0.3, 1) forwards';
		startExhaust(overlayBeanEl);
		setTimeout(() => {
			if (landingMascot) landingMascot.style.animation = '';
			overlayBeanEl.style.animation = 'beanPutter 4s ease-in-out infinite, beanVibrate 0.3s linear infinite';
			// Replace with business text, then follow up with URL quip
			const landTexts = { en: 'I see you really mean business.', nl: 'Ik zie dat u het echt meent.' };
			const el = $('#bean-overlay-typewriter');
			const savedUrl = localStorage.getItem('sm_makeover_website') || '';
			let urlName = '';
			try { urlName = new URL(savedUrl).hostname; } catch { urlName = savedUrl.replace(/^https?:\/\//, '').split(/[/?#]/)[0]; }
			if (el) typeText(el, landTexts[lang] || landTexts.en, {
				startDelay: 300,
				onDone: urlName ? () => {
					setTimeout(() => {
						const followUp = {
							en: `I\u2019ve got your enquiry for ${urlName} btw. I\u2019ll be in touch. hehe`,
							nl: `Ik heb uw aanvraag voor ${urlName} trouwens ontvangen. Ik neem contact met u op. hihi`,
						};
						typeText(el, followUp[lang] || followUp.en, { startDelay: 0 });
					}, 10000);
				} : undefined,
			});

			// Random 360 spin every 15-25s
			const mascotSpin = refRight3?.querySelector('.mascot-small');
			if (mascotSpin) {
				(function scheduleIdleSpin() {
					const delay = 15000 + Math.random() * 10000;
					setTimeout(() => {
						if (!mkOverlay.classList.contains('active')) return;
						mascotSpin.style.animation = 'beanIdleSpin 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
						mascotSpin.addEventListener('animationend', function handler() {
							mascotSpin.style.animation = '';
							mascotSpin.removeEventListener('animationend', handler);
							scheduleIdleSpin();
						});
					}, delay);
				})();
			}
		}, 9100);
	}

	// Restore hero Bean (only if Bean float isn't docked there)
	const heroMascot = document.querySelector('.mascot-wrap .mascot img');
	const heroCircle = document.querySelector('.mascot-wrap .mascot');
	const beanIsDocked = beanFloat?.classList.contains('bean-is-docked');
	if (heroMascot && !beanIsDocked) heroMascot.style.visibility = '';
	if (heroCircle && !beanIsDocked) { heroCircle.style.boxShadow = ''; heroCircle.style.border = ''; }
	const floater2 = $('#bean-float');
	if (floater2) floater2.style.display = '';
});

// Copy referral code
$('#referral-code-wrap')?.addEventListener('click', () => {
	const code = $('#referral-code')?.textContent;
	if (code) navigator.clipboard.writeText(code).catch(() => {});
	const copied = $('#referral-copied');
	if (copied) {
		copied.classList.add('show');
		setTimeout(() => copied.classList.remove('show'), 1500);
	}
});
mkOverlay?.addEventListener('click', e => {
	const card = mkOverlay.querySelector('.makeover-card');
	const bean = mkOverlay.querySelector('.overlay-bean');
	const ref = mkOverlay.querySelector('.referral-card');
	if (!card?.contains(e.target) && !bean?.contains(e.target) && !ref?.contains(e.target)) {
		closeOverlay();
	}
});

// Bean in overlay — click to hear about computers
const beanComputerQuips = {
	en: ['I just love computers so much. I\'m serious'],
	nl: ['Ik hou gewoon zo veel van computers. Echt waar.'],
};
let beanCompIdx = 0;
mkOverlay?.querySelector('.overlay-bean')?.addEventListener('click', (e) => {
	e.stopPropagation();
	const list = beanComputerQuips[lang] || beanComputerQuips.en;
	const el = $('#bean-overlay-typewriter');
	if (el) typeText(el, list[beanCompIdx++ % list.length], { startDelay: 0 });
});

// Validate required fields → enable/disable submit
const mkSubmit = $('#mk-submit');
const mkEmail = $('#mk-email');
const mkWebsite = $('#mk-website');
let mkSubmitting = false;

// Submit button sparkles
addSparkles($('#submit-wrap'), mkSubmit, 250);

// Reference to beanFloat for submit-another handler
const beanFloat = $('#bean-float');

function setMkStatus(text) {
	const el = $('#mk-status');
	if (!el) return;
	el.textContent = text;
	el.className = text ? 'form-status error' : 'form-status';
}

mkForm?.addEventListener('submit', async (e) => {
	e.preventDefault();
	if (mkSubmitting) return;
	if (!mkForm.checkValidity()) { mkForm.reportValidity(); return; }
	mkSubmitting = true;
	mkSubmit.disabled = true;
	mkSubmit.textContent = T[lang]?.overlaySending || 'Sending...';
	setMkStatus('');

	const websiteUrl = mkWebsite.value.trim();

	// Wait for the server: an enquiry that silently fails is a lost lead,
	// so the celebration only plays once the enquiry is stored/emailed.
	let ok = false;
	try {
		const res = await fetch('/api/submit', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				name: $('#mk-name').value.trim(),
				email: mkEmail.value.trim(),
				website: websiteUrl,
				style: $('#mk-style')?.value || 'professional',
				message: $('#mk-message')?.value.trim() || '',
				lang: document.documentElement.lang || 'nl',
			}),
		});
		const data = await res.json().catch(() => ({}));
		ok = res.ok && !!data?.success;
		if (!ok) console.error('Submit error:', data?.error || res.status);
	} catch (err) {
		console.error('Submit failed:', err);
	}

	if (!ok) {
		mkSubmitting = false;
		mkSubmit.disabled = false;
		mkSubmit.textContent = T[lang]?.overlaySubmit || 'Send enquiry';
		setMkStatus(T[lang]?.overlayErr || T.en.overlayErr);
		return;
	}

	// Remember website for Bean's quip, and that this visitor has enquired
	try {
		localStorage.setItem('sm_makeover_website', websiteUrl);
		localStorage.setItem(ENQUIRED_KEY, String(Date.now()));
	} catch {}

	// 1. Slide form left, bean right (0-500ms)
	const leftHalf = mkOverlay.querySelector('.makeover-left');
	const rightHalf = mkOverlay.querySelector('.makeover-right');
	leftHalf.classList.add('exit');
	rightHalf.classList.add('exit');

	setTimeout(() => {
		leftHalf.style.display = 'none';
		rightHalf.style.display = 'none';

		const refWrap = $('#referral-wrap');
		const refCard = $('#referral-card');
		const stamp = $('#referral-stamp');
		const codeWrap = $('#referral-code-wrap');
		const behind = $('#fw-behind');

		// Bean hidden initially, in his normal right-side position
		const refRight = refWrap.querySelector('.makeover-right');
		refRight.classList.add('bean-hidden');
		refRight.style.opacity = '1';
		refWrap.classList.add('active');

		// Wave 1 (0s)
		fireFireworks(behind, 8, 10, 0);

		// Show card (0.2s)
		setTimeout(() => refCard.classList.add('active'), 200);

		// Wave 2 (1s)
		setTimeout(() => fireFireworks(behind, 10, 12, 0), 1000);

		// Paw stamp + Bean slams in from huge (150ms)
		setTimeout(() => {
			// Bean scales from 12x down to 1x in his right-side spot
			refRight.classList.remove('bean-hidden');
			refRight.classList.remove('bean-can-talk');
			refRight.querySelector('.overlay-bean').style.animation = 'beanStamp 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards';

			// Paw stamp on the code
			const pawEl = document.createElement('div');
			pawEl.className = 'stamp-paw';
			stamp.appendChild(pawEl);
			pawEl.style.animation = 'pawStamp 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards';
			setTimeout(() => pawEl.remove(), 1000);

			// Code reveal + shake + Bean starts talking (2s)
			setTimeout(() => {
				codeWrap.classList.add('visible');
				refCard.style.animation = 'cardShake 1.65s ease-out';
				fireFireworks(behind, 15, 15, 0);
				fireFireworks(behind, 10, 12, 0.2);
				fireFireworks(behind, 8, 10, 0.4);
				hasSubmitted = true;
				setTimeout(() => { refCard.style.animation = ''; }, 1750);
				startContinuousFireworks(behind);

				// Bean slides to final position then talks
				setTimeout(() => {
					const beanEl = refRight.querySelector('.overlay-bean');
					beanEl.style.animation = 'beanSettle 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards';
					setTimeout(() => {
						beanEl.style.animation = '';
						beanEl.style.transform = '';
						refRight.classList.add('bean-can-talk');
						typeText($('#referral-typewriter'), thanksText(), { startDelay: 300 });

						// 5s after text appears: hide text → spin → shake → rocket
						setTimeout(() => {
							const mascotCircle = refRight.querySelector('.mascot-small');
							if (!mascotCircle) return;
							// Hide speech bubble
							refRight.classList.remove('bean-can-talk');
							const rtClear = $('#referral-typewriter');
							if (rtClear) rtClear.textContent = '';
							// Spin 3x (1.2s)
							mascotCircle.style.animation = 'beanSpin 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
							setTimeout(() => {
								// Shake for 3s
								mascotCircle.style.animation = 'beanVibrate 0.3s linear infinite';
								setTimeout(() => {
									// Rocket launch
									const beanOuter = refRight.querySelector('.overlay-bean');
									mascotCircle.style.animation = '';
									startExhaust(beanOuter);
									beanOuter.style.animation = 'beanRocket 0.4s cubic-bezier(0.3, 0, 1, 0.5) forwards';
									setTimeout(() => stopExhaust(), 500);
									// Slide panel to center after Bean is gone
									const refInner = beanOuter.closest('.makeover-inner');
									if (refInner) setTimeout(() => {
										refInner.classList.add('bean-gone');
										setTimeout(() => {
											const sa = refInner.querySelector('.submit-another');
											if (sa) sa.classList.add('visible');
										}, 1000);
									}, 2000);
									// Hide floating Bean and hero Bean
									const floater = $('#bean-float');
									if (floater) floater.style.display = 'none';
									const heroMascot = document.querySelector('.mascot-wrap .mascot img');
									if (heroMascot) heroMascot.style.visibility = 'hidden';
									const heroCircle = document.querySelector('.mascot-wrap .mascot');
									if (heroCircle) {
										heroCircle.style.boxShadow = 'none';
										heroCircle.style.borderColor = 'var(--border)';
										heroCircle.style.border = '2px dashed var(--border)';
									}
								}, 1000);
							}, 1200);
						}, 5000);
					}, 500);
					const refBean = refWrap.querySelector('.overlay-bean');
					const refMascot = refWrap.querySelector('.mascot-small');
					if (refBean && refMascot && !refBean._sparkles) {
						addSparkles(refBean, refMascot, 150);
						refBean._sparkles = true;
					}
				}, 500);
			}, 500);
		}, 150);

	}, 500);
});

// Overlay card sparkles
addSparkles(
	mkOverlay?.querySelector('.makeover-left'),
	mkOverlay?.querySelector('.makeover-card'),
	120
);
